import MenuWithLabel from '@Components/Common/Menu';
import { useOrgStore } from '@Models/useOrgModel';
import style from '@Report/OneTimeReports/index.module.less';
import { TextLabel } from '@tonic-one/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOneTimeReportStore } from '../../store';

const ReportOrg = () => {
  const { t } = useTranslation();
  const { orgId: initOrgId, orgs } = useOrgStore();

  //getter
  const orgId = useOneTimeReportStore((store) => store.generalSetting.orgId);

  //setter
  const setOrgId = useOneTimeReportStore((store) => store.setOrgId);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const cb = () => setOrgId(initOrgId);
    cb();
    register(cb);
    return () => unregister(cb);
  }, [initOrgId]);
  return (
    <>
      <TextLabel className={style.itemLabel + ' required'}>
        {t('reportCommon.labels.organization')}:
      </TextLabel>
      <MenuWithLabel
        menuItems={orgs || []}
        minWidth={287}
        selectedKey={orgId}
        onClick={(e: any) => {
          setOrgId(e.target.getAttribute('value'));
        }}
      />
    </>
  );
};

export default ReportOrg;
